import * as z from 'zod';

export const holidayFormSchema = z
  .object({
    Name: z
      .string()
      .trim()
      .min(1, { message: 'NAME_REQUIRED' })
      // Both holiday workflows paste the name into a raw GraphQL string, so a double quote or a
      // backslash would break the write.
      .refine((name) => !/["\\]/.test(name), { message: 'HOLIDAY_NAME_INVALID_CHARACTERS' }),
    HolidayDate: z.string().min(1, { message: 'DATE_REQUIRED' }),
    IsRegional: z.boolean().default(false),
    /** `Location` ids of the cantons a regional holiday applies to. */
    LocationIds: z.array(z.string()).default([]),
  })
  .refine((data) => !data.IsRegional || data.LocationIds.length > 0, {
    message: 'REQUIRED_FIELD',
    path: ['LocationIds'],
  });

export type HolidayFormValues = z.infer<typeof holidayFormSchema>;
